import ActivateTabFunc from "./activateTabFunc";

export default function InitTab() {
  var currentTab = window.location.hash;

  switch (currentTab) {
    case '#produktinfo': {
      ActivateTabFunc($('li.tab1'))
      break;
    }
    case '#leveransinfo': {
      ActivateTabFunc($('li.tab2'))
      break;
    }
    case '#recension': {
      $('#product .tabs-nav .tab3').click();
      break;
    }
    case '#priceHistory': {
      ActivateTabFunc($('li.tab4'))
      break
    }
    default: {
      ActivateTabFunc($('li.tab1'))
      break;
    }
  }
}
